export default __webpack_public_path__ + "static/media/kafka.b9a03e6b.png";